import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";
import ViewFeatureRequestPage from "../../components/Feature Request/ViewFeatureRequestPage";



const ViewFeatureRequest = () => {
    return (
        <>

            <MasterLayout>


                <Breadcrumb id="title" title2="Feature Requests" link2="/feature-requests" title="View Feature Request" />


                <ViewFeatureRequestPage />

            </MasterLayout>
        </>
    );
};

export default ViewFeatureRequest;
